import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  IconFiles,
  IconFileTypePdf,
  IconMail,
  IconMailForward,
  IconMessageForward,
  IconTrash,
} from "@tabler/icons-react";
import Select from "react-select";
import {
  Button,
  Col,
  Form,
  Row,
  InputGroup,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import EmailSuggestions from "../../../components/EmailSuggestions";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";
import PackingSlipPdfDocument from "../PackageSlipPDF/Main";
import { pdf } from "@react-pdf/renderer";
import PackingSlipAttachments from "../PackingSlipAttachments";
import PackslipAttachments from "./PackslipAttachments";

function PackingSlipEmail({
  show,
  setShow,
  order_id,
  slipData,
  notifyEmails,
  orgName,
  deliveryOrder,
  kEmail,
  shipEmail,
  attachmnetid,
  carrierType,
}) {
  const user = useSelector((state) => state.auth.user);
  const [defaultPdfAttachment, setDefaultPdfAttachment] = useState(null);
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  const [selectedOrderAttachments, setSelectedOrderAttachments] = useState({
    fileNames: [],
    fileUrls: [],
  });

  const {
    register,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    const defaults = [
      kEmail || null,
      shipEmail && shipEmail !== kEmail ? shipEmail : null,
    ].filter(Boolean);
    setValue("notification_emails", defaults);
  }, [kEmail, shipEmail]);

  const getGreeting = () => {
    const hour = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
      hour: "numeric",
      hour12: false,
    });
    const h = parseInt(hour);
    if (h < 12) return "Good morning";
    if (h < 17) return "Good afternoon";
    return "Good evening";
  };

  const defaultContent = `${getGreeting()}.<br/>
<br/>
The reference order has been shipped. Attached are the following documents for your records:
<br/>
<br/>
<strong>Agency: ${orgName || "NA"} </strong><br/>
<strong>Contract Number: ${slipData?.contract_number || "NA"}</strong><br/>
<strong>Delivery Order Number: ${slipData?.delivery_order || "NA"} </strong><br/>
<strong>Unique Identifier: ${slipData?.invoice_number || "NA"}</strong><br/>
<strong>Tracking Number: ${slipData?.tracking_number || "NA"}</strong><br/>
<br/>
If you have any questions or need further information, please feel free to reach out.`;

  const defaultSignature = `
<p>Very Respectfully,<br/>
<strong>${user?.first_name} ${user?.last_name}</strong><br/>
<strong>A:</strong> 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA<br/>
<strong>O:</strong> 540-547-8487 Ext. 100</p>`;

  const [attachFilesChecked, setAttachFilesChecked] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfGenerating, setPdfGenerating] = useState(false);

  useEffect(() => {
    // const carrierLinks = {
    //   UPS: { url: "https://www.ups.com/track", extra: '""' },
    //   FedEx: {
    //     url: "https://www.fedex.com/en-us/tracking.html",
    //     extra: '"smartCard-inline"',
    //   },
    //   Saia: { url: "https://www.saia.com/track", extra: '""' },
    // };

    // const carrier = carrierLinks[carrierType];

    const carrierLinks = {
      ups: { url: "https://www.ups.com/track" },
      fedex: {
        url: "https://www.fedex.com/en-us/tracking.html",
      },
      saia: { url: "https://www.saia.com/track" },
    };

    const carrier = carrierLinks[slipData?.carrier?.toLowerCase()];

    // const trackingBullet = carrier
    //   ? `<li>Packing List with Tracking Information (<a href="${carrier.url}" target="_blank">${carrier.url}</a>${carrier.extra ? ` ${carrier.extra}` : ""})</li>`
    //   : "";

    const pdfBullet = defaultPdfAttachment
      ? `<li>${defaultPdfAttachment.name}${carrier ? ` (<a href="${carrier.url}" target="_blank">${carrier.url}</a>${carrier.extra ? ` ${carrier.extra}` : ""})` : ""}</li>`
      : "";

    const fileListItems = [
      pdfBullet,
      ...attachments.map((f) => `<li>${f.name}</li>`),
      ...selectedOrderAttachments.fileNames.map(
        (n) => `<li>${n.split("/").pop()}</li>`,
      ),
    ]
      .filter(Boolean)
      .join("");
    // const fileListItems = [
    //   defaultPdfAttachment ? `<li>${defaultPdfAttachment.name}</li>` : "",
    //   ...attachments.map((f) => `<li>${f.name}</li>`),
    //   ...selectedOrderAttachments.fileNames.map(
    //     (n) => `<li>${n.split("/").pop()}</li>`,
    //   ),
    //   trackingBullet,
    // ]
    //   .filter(Boolean)
    //   .join("");

    const fileListHtml = fileListItems ? `<ul>${fileListItems}</ul>` : "";

    const updatedBody = `${getGreeting()}.<br/><br/>The reference order has been shipped. Attached are the following documents for your records:${fileListHtml}<br/><strong>Agency: ${orgName || "NA"}</strong><br/><strong>Contract Number: ${slipData?.contract_number || "NA"}</strong><br/><strong>Delivery Order Number: ${deliveryOrder || "NA"}</strong><br/><strong>Unique Identifier: ${slipData?.invoice_number || "NA"}</strong><br/><strong>Tracking Number: ${slipData?.tracking_number || "NA"}</strong><br/><br/>If you have any questions or need further information, please feel free to reach out.`;

    setEmailData((prev) => ({ ...prev, body: updatedBody }));
  }, [
    defaultPdfAttachment,
    attachments,
    selectedOrderAttachments.fileNames,
    slipData?.carrier,
  ]);

  const [emailData, setEmailData] = useState({
    order_id: order_id || "",
    from_email: "logistics@aspettoinc.com",
    to_email: "",
    to_name: "",
    cc: ["ar_receivables@aspettoinc.com", "logistics@aspettoinc.com"],
    subject: `Shipment Confirmation and Documentation for ${order_id}`,
    body: defaultContent,
    Email_SentBy_Name: `${user?.first_name} ${user?.last_name}`,
    Email_SentBy_Email: user?.email,
    is_attach: false,
    attachment_names: "",
    signature: defaultSignature,
  });

  const handleAttachmentChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const newFiles = Array.from(event.target.files);
      setAttachments((prev) => [...prev, ...newFiles]);
      const newFileNames = newFiles.map((f) => f.name).join(" ");
      setEmailData((prev) => ({
        ...prev,
        attachment_names: prev.attachment_names
          ? `${prev.attachment_names} ${newFileNames}`
          : newFileNames,
      }));
    }
  };

  useEffect(() => {
    if (!slipData) return;

    const generatePdf = async () => {
      setPdfGenerating(true);
      try {
        const pdfDoc = (
          <PackingSlipPdfDocument
            invoicedata={slipData}
            items={slipData.products}
            loggedInUser={user}
          />
        );
        const blob = await pdf(pdfDoc).toBlob();
        const url = URL.createObjectURL(blob);
        setPdfBlob(blob);
        setPdfUrl(url);
        setDefaultPdfAttachment({
          name: `PackingSlip_${order_id}.pdf`,
          isDefault: true,
          blob: blob,
        });
      } catch (err) {
        console.error("Failed to generate packing slip PDF:", err);
        toast.error("Failed to generate PDF preview.");
      } finally {
        setPdfGenerating(false);
      }
    };

    generatePdf();

    // Cleanup blob URL on unmount
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [slipData]);

  const removeAttachment = (indexToRemove) => {
    setAttachments((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const { data: EmailUSerData, postData: fetchEmails } = usePostRequest(
    API_ENDPOINTS.EMAIL_ALL_USERS,
  );

  const { isLoading: sendLoading, postData: SendEmail } = usePostRequest(
    API_ENDPOINTS.PACKING_SLIP_EMAIL,
  );

  useEffect(() => {
    fetchEmails();
  }, []);

  const onSuccess = () => {
    toast.success("Email Sent Successfully!");
    setShow({ show: false });
  };

  const onError = (error) => {
    toast.error(error.message || "Failed to send email.");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append(
      "order_attachment",
      JSON.stringify(selectedOrderAttachments.fileNames),
    );
    formData.append(
      "order_attachments",
      JSON.stringify(selectedOrderAttachments.fileUrls),
    );

    // const ccEmails = watch("cc_emails") || [];
    // formData.append("cc", JSON.stringify(ccEmails));

    formData.append("id", slipData?.id || "");

    if (pdfBlob) {
      formData.append(
        "pdf",
        new File([pdfBlob], `PackingSlip_${order_id}.pdf`, {
          type: "application/pdf",
        }),
      );
    }

    attachments.forEach((file) => {
      formData.append("pdf", file, file.name);
    });

    const toEmails = watch("notification_emails") || [];
    formData.append(
      "notification_emails",
      Array.isArray(toEmails) ? toEmails.join(",") : toEmails,
    );

    formData.append("body", emailData.body || "");
    formData.append("subject", emailData.subject || "");
    formData.append("signature", emailData.signature || "");
    formData.append("cc", JSON.stringify(emailData.cc));

    SendEmail(formData, onSuccess, onError);
  };

  useEffect(() => {
    if (notifyEmails) {
      const emailsFromRow =
        typeof notifyEmails === "string"
          ? notifyEmails
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean)
          : Array.isArray(notifyEmails)
            ? notifyEmails
            : [];

      const validEmails = emailsFromRow.filter((email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
      );

      console.log("validEmails", validEmails);

      setUserEmails(validEmails);
    }
  }, [notifyEmails]);

  return (
    <>
      <PackslipAttachments
        show={showAttachmentsModal}
        onHide={() => setShowAttachmentsModal(false)}
        attachmnetid={attachmnetid}
        onConfirm={({ fileNames, fileUrls }) =>
          setSelectedOrderAttachments({ fileNames, fileUrls })
        }
      />
      <Modal
        scrollable
        show={show}
        onHide={() => setShow({ show: false })}
        dialogClassName="modal-90w"
        size="lg"
      >
        <Modal.Header className="gap-2" closeButton>
          <span className="avatar bg-blue-lt rounded-circle">
            <IconMailForward stroke={1.25} />
          </span>
          <div>
            <Modal.Title>Packing Slip Mail</Modal.Title>
            <small className="text-muted">Order ID: {order_id}</small>
          </div>
          {/* <div className="ms-auto">
          {pdfGenerating ? (
            <Spinner animation="border" size="sm" title="Generating PDF..." />
          ) : pdfUrl ? (
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => window.open(pdfUrl, "_blank")}
            >
              <IconFileTypePdf stroke={1} /> View Generated PDF
            </Button>
          ) : (
            <span className="text-muted small">No PDF yet</span>
          )}
        </div> */}
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>From</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconMail stroke={1} />
                    </InputGroup.Text>
                    <Form.Control value={emailData.from_email} disabled />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>To</Form.Label>
                  <Controller
                    name="notification_emails"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                      <EmailSuggestions
                        {...field}
                        suggestionsSource={userEmails}
                        key={userEmails.join(",")}
                        validate={(email) =>
                          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                        }
                        errorMessage="Invalid email format"
                        placeholder="Enter email and press Enter"
                      />
                    )}
                  />
                </Form.Group>
              </Col>

              {/* <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>To</Form.Label>
                  <Select
                    onChange={(selectedOptions) => {
                      setValue(
                        "notification_emails",
                        selectedOptions.map((o) => o.value),
                      );
                    }}
                    defaultValue={[
                      kEmail ? { label: kEmail, value: kEmail } : null,
                      shipEmail && shipEmail !== kEmail
                        ? { label: shipEmail, value: shipEmail }
                        : null,
                    ].filter(Boolean)}
                    key={userEmails.join(",")}
                    isMulti
                    name="to_email"
                    options={userEmails.map((e) => ({ label: e, value: e }))}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </Form.Group>
              </Col> */}

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Add other emails to CC</Form.Label>
                  <Controller
                    name="cc_emails"
                    control={control}
                    defaultValue={[
                      "logistics@aspettoinc.com",
                      "ar_receivables@aspettoinc.com",
                    ]}
                    render={({ field }) => (
                      <EmailSuggestions
                        {...field}
                        suggestionsSource={
                          EmailUSerData?.data?.map((u) => u.email) || []
                        }
                        validate={(email) =>
                          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                        }
                        errorMessage="Invalid email format"
                        placeholder="Enter email and press Enter"
                        onChange={(emails) => {
                          field.onChange(emails);
                          setEmailData((prev) => ({ ...prev, cc: emails }));
                        }}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              {/* <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Add other emails to CC</Form.Label>
                  <Select
                    onChange={(selectedOptions) => {
                      const newCC = [
                        "quotesandsales@aspettoinc.com",
                        ...selectedOptions.map((o) => o.value),
                      ];
                      setEmailData({ ...emailData, cc: newCC });
                    }}
                    defaultValue={[
                      {
                        label: "logistics@aspettoinc.com",
                        value: "logistics@aspettoinc.com",
                      },
                      {
                        label: "ar_receivables@aspettoinc.com",
                        value: "ar_receivables@aspettoinc.com",
                      },
                    ]}
                    isMulti
                    name="cc"
                    options={
                      EmailUSerData?.data?.map((u) => ({
                        label: u.email,
                        value: u.email,
                      })) || []
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </Form.Group>
              </Col> */}

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconMessageForward stroke={1} />
                    </InputGroup.Text>
                    <Form.Control
                      value={emailData.subject}
                      onChange={(e) =>
                        setEmailData({ ...emailData, subject: e.target.value })
                      }
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={12}>
                <ReactQuill
                  className="mb-3"
                  theme="snow"
                  value={emailData.body}
                  onChange={(value) =>
                    setEmailData({ ...emailData, body: value })
                  }
                  placeholder="Body"
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                {/* <div className="bs-stepper-header stepper_komail mb-3">
                <div className="formrow">
                  <input
                    className="checkbox"
                    type="checkbox"
                    id="Attachment"
                    checked={attachFilesChecked}
                    onChange={(e) => {
                      setAttachFilesChecked(e.target.checked);
                      setEmailData({
                        ...emailData,
                        is_attach: e.target.checked,
                      });
                    }}
                  />
                  <label
                    htmlFor="Attachment"
                    className="checklabel step-trigger"
                  >
                    Attach Files
                  </label>
                </div>
              </div> */}

                {/* {attachFilesChecked && ( */}
                <>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="attachment-input">
                      Attach File(s)
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control custom-file-input"
                        accept="image/*, .pdf, .doc, .docx"
                        id="attachment-input"
                        multiple
                        type="file"
                        onChange={handleAttachmentChange}
                      />
                      <span className="select_count">
                        {attachments.length === 0
                          ? "No File Chosen"
                          : `${attachments.length} File${attachments.length > 1 ? "s" : ""}`}
                      </span>
                    </div>
                  </div>

                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="mb-3"
                    onClick={() => setShowAttachmentsModal(true)}
                  >
                    <IconFiles stroke={1} className="me-1" />
                    Upload Order Attachments
                    {/* {selectedOrderAttachments.fileNames.length > 0 && (
                      <span className="ms-1 badge bg-primary">
                        {selectedOrderAttachments.fileNames.length} selected
                      </span>
                    )} */}
                  </Button>

                  {/* {attachments.length > 0 && (
                    <ListGroup className="mb-3">
                      {attachments.map((file, index) => (
                        <ListGroup.Item key={index}>
                          {file.name}
                          <span
                            className="trash_files text-danger"
                            style={{ cursor: "pointer", marginLeft: "8px" }}
                            onClick={() => removeAttachment(index)}
                          >
                            <IconTrash size={16} />
                          </span>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )} */}
                  {/* Always-visible default PDF attachment */}
                  <ListGroup className="mb-3">
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <span className="d-flex align-items-center gap-2">
                        <IconFileTypePdf
                          stroke={1}
                          style={{ color: "#D63939" }}
                        />
                        {pdfGenerating ? (
                          <span className="text-muted">Generating PDF...</span>
                        ) : defaultPdfAttachment ? (
                          <span
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={() =>
                              pdfUrl && window.open(pdfUrl, "_blank")
                            }
                          >
                            {defaultPdfAttachment.name}
                          </span>
                        ) : (
                          <span className="text-muted">
                            PDF not yet generated
                          </span>
                        )}
                      </span>
                      {pdfGenerating && (
                        <Spinner animation="border" size="sm" />
                      )}
                    </ListGroup.Item>

                    {/* Manual uploads below the default */}
                    {attachments.map((file, index) => (
                      <ListGroup.Item
                        key={index}
                        className="d-flex align-items-center justify-content-between"
                      >
                        <span>{file.name}</span>
                        <span
                          className="trash_files text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => removeAttachment(index)}
                        >
                          <IconTrash size={16} />
                        </span>
                      </ListGroup.Item>
                    ))}
                    {selectedOrderAttachments.fileNames.map((name, index) => (
                      <ListGroup.Item
                        key={`order-${index}`}
                        className="d-flex align-items-center justify-content-between"
                      >
                        <span className="d-flex align-items-center gap-2">
                          {/* <IconFileTypePdf
                            stroke={1}
                            style={{ color: "#D63939" }}
                          /> */}
                          <span>{name}</span>
                        </span>
                        <span
                          className="trash_files text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setSelectedOrderAttachments((prev) => ({
                              fileNames: prev.fileNames.filter(
                                (_, i) => i !== index,
                              ),
                              fileUrls: prev.fileUrls.filter(
                                (_, i) => i !== index,
                              ),
                            }))
                          }
                        >
                          <IconTrash size={16} />
                        </span>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </>
                {/* )} */}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <ReactQuill
                  className="mb-3"
                  theme="snow"
                  value={emailData.signature}
                  onChange={(value) =>
                    setEmailData((prev) => ({ ...prev, signature: value }))
                  }
                  placeholder="Signature"
                />
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={3}>
                <Button variant="warning" type="submit" className="w-100">
                  {sendLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PackingSlipEmail;
